export enum SceneNames {
	WaterFaucet = 'water-faucet-scene',
	Transport = 'transport-scene',
	LightSwitch = 'light-switch-scene',
	Final = 'final-scene',
}
